import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from 'rxjs';
import {ClickService} from '../../../core/services/click.service';
import {EscapeKeyService} from '../../../core/services/escape-key.service';

@Component({
    template: '',
    styleUrls: ['./base-drawer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class BaseDrawerComponent implements OnInit, OnDestroy {
  private clickSub: Subscription;
  private unregisterEsc = () => {};

  @Input() addToZIndex: number = 0;
  @Output() clickedOutside$: EventEmitter<null> = new EventEmitter<null>();
  @ViewChild('shade') $shadeEl;

  protected bodyStyle: CSSStyleDeclaration;
  cssZIndex: number;


  constructor(
    protected clickService: ClickService,
    protected escapeKeyService: EscapeKeyService,
  ) {
  }


  ngOnInit(): void {
    this.bodyStyle = getComputedStyle(document.body);

    const zIndexShade = +this.bodyStyle.getPropertyValue('--motn-z-index-shade');
    this.cssZIndex = zIndexShade + 1 + this.addToZIndex;

    this.onInit();

    this.clickSub = this.clickService.click$.subscribe(
      ($el) => {
        if (this.$shadeEl.nativeElement === $el) {
          this.clickedOutside$.emit(null);
        }
      },
    );

    this.unregisterEsc = this.escapeKeyService.register(() => this.clickedOutside$.emit(null));
  }


  ngOnDestroy() {
    this.clickSub?.unsubscribe();
    this.unregisterEsc();
  }


  protected abstract onInit();

}
